import { useFeatureGate } from '@statsig/react-bindings';
import { useAuthUser } from './useAuth';

/**
 * Returns true if the user management feature is enabled.
 * Access is granted if the user_management feature flag is on OR the user is a Superuser.
 */
export const useUserManagementEnabled = (): boolean => {
  const { value: featureEnabled } = useFeatureGate('user_management');
  const { isSuperUser } = useAuthUser();
  return featureEnabled || isSuperUser;
};
